export default {"src":"/_next/static/media/home-highlight-lg.35c69a43.svg","height":86,"width":150,"blurWidth":0,"blurHeight":0};